<template>
  <div class="monit-page">
    <div :class="`monit-main column`" :style="layoutLoading">
      <h4 v-if="mobile" class="page-title col-xs-12 pt-1">Estação</h4>
      <div v-if="loading" class="col-xs-12 center-xs mt-2">
        <spinner /> Buscando estação...
      </div>

      <div class="col-xs-12 pt-xl-2" v-show="!loading">
        <div class="container-card">
          <div class="title-card">
            <settings-outline-icon title="configuração" />
            <span>Configuração da estação</span>
          </div>
          <div class="col-xs-12 config-details">
            <div class="row">
              <div :class="chartLossDays.length ? 'col-xs-12 col-sm-6' : 'col-xs-12'">
                <div class="group-info">
                  <span class="title">Latitude:</span>
                  <span>
                    {{
                      station && station.LATITUDE
                        ? station.LATITUDE.toFixed(5)
                        : "Não há dado configurado."
                    }}
                  </span>
                </div>

                <div class="group-info">
                  <span class="title">Longitude:</span>
                  <span>
                    {{
                      station && station.LONGITUDE
                        ? station.LONGITUDE.toFixed(5)
                        : "Não há dado configurado."
                    }}
                  </span>
                </div>

                <div class="group-info">
                  <span class="title">Altitude:</span>
                  <span>
                    {{
                      station && station.ALTITUDE
                        ? station.ALTITUDE.toFixed(2) + " m"
                        : "Não há dado configurado."
                    }}
                  </span>
                </div>
                <div class="group-info">
                  <span class="title">Altura do anemômetro:</span>
                  <span>
                    {{
                      station && station.H_ANEMOMETRO
                        ? station.H_ANEMOMETRO.toFixed(2) + " m"
                        : "Não há dado configurado."
                    }}
                  </span>
                </div>
              </div>

              <div v-if="chartLossDays.length" class="col-xs-12 col-sm-6 health-col">
                <b-alert show variant="warning" class="mb-0 station-health-alert">
                  <strong>Perda de dados da estação</strong> em
                  {{ chartLossDays.length }} dia(s) da última semana:
                  <ul class="mb-0 mt-1 station-health-list">
                    <li v-for="d in chartLossDays" :key="d.date">
                      {{ lossDayText(d) }}
                      <span v-if="d.resolved">— suprido manualmente</span>
                      <span v-else-if="!d.consolidated">— sem ET0 (não consolidado)</span>
                    </li>
                  </ul>
                </b-alert>
              </div>
            </div>
          </div>
        </div>

        <div class="container-card mt-2">
          <div class="title-card mt-2">Relatórios</div>
          <div class="row">
            <div class="col-xs-12 col-xl-6 col-sm-6">
              <b-button
                v-if="!!sensorId"
                size="sm"
                :class="`p-2 mb-1`"
                variant="3v3"
                @click="showPureForm('EXPORTAR DADOS BRUTOS')"
                block
              >
                EXPORTAR DADOS BRUTOS
              </b-button>

              <div v-else>
                <b-button
                  v-b-toggle="'collapse-1'"
                  class="mb-1 p-2 w-100"
                  variant="outline-primary"
                >
                  Por que não consigo acessar os dados brutos?
                </b-button>
                <b-collapse id="collapse-1" class="mb-1">
                  <b-card
                    >É necessário ter um sensor EMR atrelado ao dispositivo de
                    estação.</b-card
                  >
                </b-collapse>
                <!-- <b-link>Por que não consigo acessar os dados brutos?</b-link> -->
              </div>
            </div>
            <div class="col-xs-12 col-xl-6 col-sm-6">
              <b-button
                v-if="!disableETZeroReport"
                size="sm"
                class="p-2"
                variant="3v3"
                @click="showET0Form('EXPORTAR ET0')"
                block
              >
                EXPORTAR ET0
              </b-button>

              <div v-else>
                <b-button
                  v-b-toggle="'collapse-2'"
                  size="sm"
                  class="mb-1 p-2 w-100"
                  variant="outline-primary"
                  @click="
                    showForm = false;
                    showET0Errors = !showET0Errors;
                  "
                >
                  Por que não consigo calcular ET0?
                </b-button>
                <b-collapse id="collapse-2">
                  <b-card>
                    <div v-if="showET0Errors">
                      Para calcular a ET0, você precisa:
                      <ul>
                        <li v-for="(err, index) in reportErrs" :key="index">
                          {{ err }}
                        </li>
                      </ul>
                    </div>
                  </b-card>
                </b-collapse>
              </div>
            </div>

            <b-card class="w-100 m-2" v-show="showForm">
              <h6 v-text="titleDropdown"></h6>

              <b-form
                v-show="showForm"
                novalidate
                @keyup.enter="downloadReport"
              >
                <b-form-text id="stationStart"> Início* </b-form-text>
                <b-form-input
                  v-model="date.START_DATE"
                  aria-describedby="stationStart"
                  id="stationStart"
                  type="date"
                  :state="startState"
                />
                <b-form-text id="stationEnd"> Fim* </b-form-text>
                <b-form-input
                  v-model="date.END_DATE"
                  aria-describedby="stationEnd"
                  id="stationEnd"
                  type="date"
                  :state="endState"
                />
                <b-form-text id="stationTime" v-if="date.type == 'et0'">
                  Hora*
                </b-form-text>
                <b-form-select
                  v-if="date.type == 'et0'"
                  v-model="date.TIME"
                  aria-describedby="stationTime"
                  id="stationTime"
                  :options="hours"
                />

                <div class="row" v-if="date.type == 'et0'">
                  <div class="col-xs-6">
                    <b-form-text id="measures"> Mostrar </b-form-text>
                    <b-form-select
                      v-model="organizeET0.measures"
                      aria-describedby="stationTime"
                      id="stationTime"
                      :options="[
                        {
                          value: 2,
                          text: 'Máx e mín',
                        },
                        {
                          value: 1,
                          text: 'Média',
                        },
                      ]"
                    />
                  </div>
                  <div class="col-xs-6">
                    <b-form-text id="stationEnd"> Radiação em </b-form-text>
                    <b-form-select
                      v-model="organizeET0.rad"
                      aria-describedby="stationTime"
                      id="stationTime"
                      :options="['kJ/m²', 'w/m²']"
                    />
                  </div>
                  <div class="col-xs-12">
                    <b-form-checkbox
                      v-model="organizeET0.dpv"
                      class="mt-2"
                      switch
                    >
                      Incluir DPV (déficit de pressão de vapor)
                    </b-form-checkbox>
                  </div>
                </div>

                <br />

                <b-btn
                  ref="btnStationReport"
                  @click="downloadReport('pdf')"
                  variant="secondary"
                  block
                >
                  <report-icon
                    class="mr-1"
                    style="font-size: 1em; vertical-align: -3%"
                    title=""
                  />Gerar relatório (PDF)
                </b-btn>

                <b-btn
                  ref="btnStationReport"
                  @click="downloadReport('xlsx')"
                  variant="secondary"
                  block
                >
                  <report-icon
                    class="mr-1"
                    style="font-size: 1em; vertical-align: -3%"
                    title=""
                  />Gerar relatório (XLSX)
                </b-btn>

                <b-btn
                  ref="btnStationReport"
                  @click="downloadReport('csv')"
                  variant="secondary"
                  block
                >
                  <report-icon
                    class="mr-1"
                    style="font-size: 1em; vertical-align: -3%"
                    title=""
                  />Gerar relatório (CSV)
                </b-btn>
              </b-form>
            </b-card>
          </div>
          <Tabulator
            v-if="createTabulator"
            :data="tableData"
            :columns="tableColumns"
            :type="typeTable"
            :local="getLocal"
            @clean="CleanTabulator"
          />
        </div>
      </div>
      <div
        class="col-xs-12 content chart mt-2 container-card m-2"
        v-show="!loading && chartItems.length"
      >
        <div v-if="chartItems.length" class="title-card">
          Gráficos de estação
        </div>
        <div class="row center-xs" v-if="chartItems.length">
          <div class="col-xs-12">
            <chart-station
              :items="chartItems"
              :altitude="station.ALTITUDE"
              :anemometer-height="station.H_ANEMOMETRO"
              :longitude="station.LONGITUDE"
              :latitude="station.LATITUDE"
              :utc="utc"
              :name-station="`Estação ${station.ADDR}`"
            />
          </div>
        </div>
      </div>
    </div>

    <dirs-details
      v-if="!mobile && !showSensorDetails && !showStationDetails && !loading"
      :item="dir"
      :status-color="dirVariant"
      :variant="dirVariant"
      :updated="dirUpdated"
      :show-details="showDirDetails"
      :visible-close="false"
      data-station="disableBottom"
      :success-percentage="
        Object.keys(dir).length &&
        dir.RF &&
        calculatePercentage(dir.RF.ack[0], dir.RF.ack[1])
      "
      @close-details="showDirDetails = false"
    />
    <b-modal
      ref="formError"
      no-close-on-backdrop
      centered
      hide-header
      hide-footer
      size="sm"
      body-bg-variant="warning"
    >
      <h5>Atenção!</h5>
      <div class="row">
        <div class="col-xs-12">
          Não é possível realizar a busca de dados porque
        </div>
        <div class="col-xs-3 center-xs">
          <alert-icon title="" style="font-size: 3em" />
        </div>
        <ul class="col-xs-9">
          <li v-for="err in errors" :key="err">{{ err }}</li>
        </ul>
      </div>
      <b-btn
        v-if="$refs.formError"
        block
        variant="light"
        size="sm"
        @click="$refs.formError.hide"
        >Vou corrigir</b-btn
      >
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import Tabulator from "./components/Tabulator";
// import { ExcelFormatter } from "xlsx-generator";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

import { updateFormatter, organizer } from "@/pages/components/helpers";
import { monit, stations } from "@/api";

// Colunas psicrométricas do relatório horário, na ordem da tabela. `paired` segue o
// seletor máx/mín × méd; o DPV é escalar (uma coluna nos dois modos) porque o valor
// exibido é o que o motor de ET0 consome — não há máx/mín dele.
const HOURLY_COLUMNS = [
  { key: "temp", paired: true },
  { key: "humid", paired: true },
  { key: "dew", paired: true },
  { key: "vpd", paired: false },
  { key: "pres", paired: true },
];

// Margem lateral do PDF. Cabeçalho e rodapé se apoiam nela dos dois lados, formando
// a moldura dentro da qual a tabela é centralizada.
const PAGE_SIDE_MARGIN = 24;

// Rumo central de cada setor da rosa dos ventos (graus, 0 = N, horário). A seta do
// PDF aponta para o setor nomeado — a origem do vento, como o sensor reporta.
const WINDROSE_BEARINGS = {
  N: 0, NNE: 22.5, NE: 45, ENE: 67.5,
  E: 90, ESE: 112.5, SE: 135, SSE: 157.5,
  S: 180, SSO: 202.5, SO: 225, OSO: 247.5,
  O: 270, ONO: 292.5, NO: 315, NNO: 337.5,
};

export default {
  name: "station",
  components: {
    Tabulator,
  },
  created() {
    this.controller = new AbortController();
    this.$emit("title-change", "Estação");
    monit
      .station(this.controller)
      .then((ret) => {
        this.loading = false;
        if (ret.status) {
          this.showDirDetails = true;
          this.station = ret.value[0];
          if (this.$route.params.id == "EMR") this.selected = ret.value[0];
          this.sensorId = this.station.EMR;
          this.monitLoop();
          stations
            .chartSensors()
            .then((list) => (this.chartSensors = Array.isArray(list) ? list : []))
            .catch(() => {});
          stations
            .dataHealth(8)
            .then((h) => (this.dataHealth = h))
            .catch(() => {});
        } else {
          this.station = { ID: null };
          alert(ret.log, ret.alert);
        }
      })
      .then(() => {
        if (!this.sensorId) {
          this.reportErrs.push(
            "Ter um sensor de estação atribuído ao dispositivo."
          );
        }
        if (this.station && Object.keys(this.station).length) {
          if (!this.station.LATITUDE || !this.station.LONGITUDE)
            this.reportErrs.push(
              "Que a estação tenha coordenadas configuradas."
            );
          if (!this.station.ALTITUDE)
            this.reportErrs.push("Que a altitude esteja configurada.");
          if (!this.station.H_ANEMOMETRO)
            this.reportErrs.push("Configurar a altura do anemômetro.");
          this.disableETZeroReport = !!this.reportErrs.length;
        } else this.disableETZeroReport = true;
      })
      .catch((err) => {
        console.error(err);
      });
  },
  props: {
    local: [String],
    utc: [String, Number],
    mobile: Boolean,
  },
  data() {
    return {
      showForm: false,
      loading: true,
      loadingCharts: false,
      showDirDetails: false,
      showSensorDetails: false,
      showStationDetails: false,
      active: "info",
      // Série horária de ET0 + stats calculadas no backend, indexada por [date][hh].
      et0Map: {},
      // Saúde de dados da estação (dias recentes com perda de cobertura horária).
      dataHealth: null,
      dir: {},
      selected: {},
      timeout: null,
      controller: null,
      // dirController: null,
      // sensorController: null,
      type: "station",
      disableETZeroReport: false,
      reportErrs: [],
      errors: [],
      station: null,
      stationRF: null,
      sensorId: 0,
      sensors: [],
      measuresPositions: [],
      sensorsDetails: [],
      sensorsDetailsFlag: false,
      chartSensors: [],
      stationParameters: {},
      thHeaders: [
        "TEMPERATURA (°C)",
        "UMIDADE (%)",
        "PTO. ORVALHO (°C)",
        "PRESSÃO (hPa)",
        "VENTO (m/s)",
        "RADIAÇÃO",
        "CHUVA",
      ],
      daysToTable: [],
      hours: [
        "00",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
      ],
      date: {
        START_DATE: "",
        END_DATE: "",
        TIME: "00",
        type: "",
      },
      organizeET0: {
        measures: 2, //por padrão mostra-se máx e mín
        rad: "kJ/m²",
        dpv: true,
      },
      showET0Errors: false,
      dirDetailsWidth: 0,
      tableData: [],
      tableColumns: [],
      createTabulator: false,
      typeTable: "",
      titleDropdown: "",
    };
  },
  watch: {
    showStationDetails(newValue, oldValue) {
      if (!newValue && oldValue) this.active = "info";
    },
    selected(newValue, oldValue) {
      if (Object.keys(newValue).length && newValue.ID != oldValue.ID)
        this.active = "info";
    },
    $route(newRoute) {
      if (newRoute.params.id) {
        this.selected =
          newRoute.params.id == "EMR"
            ? this.station
            : this.sensors.filter((e) => e.NAME == newRoute.params.id)[0];
      } else this.selected = {};
    },
    mobile() {
      this.showDetailsStation(this.active);
    },
    active(newValue, oldValue) {
      this.showDetailsStation(this.active);
    },
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
    this.controller ? this.controller.abort() : null;
    // this.dirController ? this.dirController.abort() : null;
    // this.sensorController ? this.sensorController.abort() : null;
  },
  computed: {
    // Colunas psicrométricas efetivas do relatório; o DPV é opcional no formulário.
    hourlyColumns() {
      return HOURLY_COLUMNS.filter((c) => c.key !== "vpd" || this.organizeET0.dpv);
    },
    et0PsychroColumnCount() {
      return this.hourlyColumns.reduce(
        (n, c) => n + (c.paired ? this.organizeET0.measures : 1),
        0
      );
    },
    // data, hora, psicrométricas, vento méd/raj, seta, direção, radiação, chuva, ET0
    et0PdfColumnCount() {
      return 2 + this.et0PsychroColumnCount + 7;
    },
    // A seta é um glifo de 9pt: com o padding padrão a coluna ficaria larga à toa.
    et0ArrowColumnIndex() {
      return 2 + this.et0PsychroColumnCount + 2;
    },
    // Perdas dentro da janela do gráfico (1 semana), até ontem — hoje nunca fecha 24h.
    chartLossDays() {
      const days = this.dataHealth && this.dataHealth.lossDays;
      if (!Array.isArray(days) || !days.length) return [];
      const from = moment().subtract(1, "week").format("YYYY-MM-DD");
      const until = moment().subtract(1, "days").format("YYYY-MM-DD");
      return days.filter((d) => d.date >= from && d.date <= until);
    },
    getLocal() {
      let info = this.local;
      return info == ""
        ? "-"
        : info
            .toLowerCase()
            .split(" ")
            .map((word) => word[0].toUpperCase() + word.substr(1))
            .join(" ");
    },
    layoutLoading() {
      // Reserva a largura do painel lateral (dirs-details) pela MESMA condição que o renderiza,
      // para o espaço estar certo antes dos gráficos — não depende do firmware (sensorsDetails).
      const hasSidePanel =
        !this.loading &&
        !this.mobile &&
        !this.showSensorDetails &&
        !this.showStationDetails;
      return `
        width: calc(100%${hasSidePanel ? " - 361px" : ""});
        transition: 0.1s;
        overflow-y: auto;
        height: 100%;`;
    },
    startState() {
      if (this.date.START_DATE) {
        return (
          this.convertDateStringToDate(this.date.START_DATE).getFullYear() >
          2000
        );
      }
      return !!this.date.START_DATE;
    },
    endState() {
      if (this.date.END_DATE) {
        return (
          this.convertDateStringToDate(this.date.END_DATE).getFullYear() > 2000
        );
      }
      return !!this.date.END_DATE;
    },
    InvalidDateDifference() {
      if (
        this.calculateDateDifference(this.date.START_DATE, this.date.END_DATE) >
        31
      )
        return true;
    },
    updated() {
      return Object.keys(this.selected).length && this.selected.TIME
        ? this.formatUpdate(this.selected.TIME)
        : "";
    },
    variant() {
      return Object.keys(this.selected).length
        ? this.setBG(this.selected.STATUS).split("-")[1]
        : "bg-grey";
    },
    dirUpdated() {
      return Object.keys(this.dir).length && this.dir.UPDATE
        ? this.formatUpdate(this.dir.UPDATE)
        : "";
    },
    dirVariant() {
      return Object.keys(this.dir).length
        ? this.BGRF(this.dir.RF && this.dir.RF.stat).split("-")[1]
        : "bg-grey";
    },
    // Lista de sensores do gráfico/relatório vem do cadastro; firmware alimenta só o painel lateral.
    chartItems() {
      return this.chartSensors;
    },
  },
  methods: {
    lossDayText(d) {
      const day = moment(d.date).format("DD/MM");
      if (d.empty) return `${day}: estação sem dados o dia inteiro`;
      const hours = d.missingHours
        .map((m) => `${String(m.hour).padStart(2, "0")}h`)
        .join(", ");
      return `${day}: ${d.coveredHours}/${d.totalHours} horas — faltou em ${hours}`;
    },
    calculateDateDifference(startDateString, endDateString, separator = "-") {
      const startDate = this.convertDateStringToDate(
        startDateString,
        separator
      );
      const endDate = this.convertDateStringToDate(endDateString, separator);
      const differenceInMilliseconds = endDate - startDate;
      const differenceInDays = differenceInMilliseconds / (1000 * 60 * 60 * 24);
      return differenceInDays;
    },

    convertDateStringToDate(dateString, separator = "-") {
      const [year, month, day] = dateString.split(separator);
      return new Date(year, month - 1, day);
    },
    showDetailsStation(active) {
      let details = document.getElementById("details");
      let header = document.getElementById("header");
      let footer = document.getElementById("footer");
      if (active == "info") {
        this.showIo = "";
        let width = "320px";
        if (details && header && footer) {
          details.style.width = width;
          header.style.width = width;
          footer.style.width = width;
        }
        return;
      } else if (active == "charts") {
        let width = this.mobile ? "100%" : "calc(100% - 51px)";
        if (details && header && footer) {
          details.style.width = width;
          header.style.width = width;
          footer.style.width = width;
          return;
        }
      }
    },
    selectDetails(idx) {
      let tabs = ["info", "charts"];
      this.active = tabs[idx];
    },
    monitLoop() {
      // this.dirController = new AbortController();
      monit
        // .dir(this.dirController)
        .dir(this.controller)
        .then((res) => {
          return res.json();
        })
        .then((ret) => {
          if (ret.length && this.showDirDetails) {
            this.dir =
              ret.filter((e) => {
                return e.ID == this.station.ADDR;
              })[0] || {};
          }
          // this.sensorController = new AbortController();
        })
        .then((_) =>
          // !this.sensorsDetailsFlag ? monit.sensor(this.sensorController) : false
          !this.sensorsDetailsFlag ? monit.sensor(this.controller) : false
        )
        .then((res) => {
          if (res) {
            this.backendNow = Date.parse(res.headers.get("date"));
            return res.json();
          } else return;
        })
        .then((ret) => {
          let list =
            ret && ret.length
              ? ret.filter((e) => e.ID_S == `${this.sensorId}_sns`)
              : [];
          if (list.length) {
            list = list.filter((e) => !!e);
            if (list.length && !this.sensorsDetailsFlag) {
              this.sensorsDetails = list;
              this.sensorsDetailsFlag = true;
            }
          }
          // this.sensors = list;
        })
        .catch((e) => console.error(e))
        .then((_) => {
          this.timeout = setTimeout(this.monitLoop, 2000);
        });
    },
    calculatePercentage(value, ref) {
      if (!ref) return 0;
      let percent = (value * 100) / ref;
      if (percent > 100) return 100;
      else if (percent < 0) return 0;
      else return parseInt(percent);
    },
    formatUpdate(update) {
      return updateFormatter(update);
    },
    setBG(status) {
      switch (status) {
        case "low":
          return "bg-red";
        case "multi":
          return "bg-orange";
        case "high":
          return "bg-yellow";
        case "ok":
          return "bg-3v3";
        default:
          return "bg-grey";
      }
    },
    BGRF(stat) {
      switch (stat) {
        case 0:
          return "bg-3v3";
        case 7:
          return "bg-yellow";
        case 8:
          return "bg-red";
        case 9:
          return "bg-black";
        default:
          return "bg-grey";
      }
    },
    openSensorDetails(item) {
      this.selected = item;
      this.showSensorDetails = true;
    },
    resetForm() {
      this.date = {
        START_DATE: "",
        END_DATE: "",
        TIME: "00",
      };
      this.organizeET0 = {
        measures: 2, //por padrão mostra-se máx e mín
        rad: "kJ/m²",
        dpv: true,
      };
    },
    showPureForm(txt) {
      this.titleDropdown = txt;
      this.resetForm();
      this.showET0Errors = false;
      this.date.type = "pure";
      this.showForm = true;
      this.$refs.btnStationReport.focus();
    },
    showET0Form(txt) {
      this.titleDropdown = txt;
      this.resetForm();
      this.date.type = "et0";
      // this.Kc = null;
      this.showForm = true;
      this.$refs.btnStationReport.focus();
    },
    makeDaysArray(start, end) {
      let date = moment(start).format("YYYY-MM-DD");
      end = moment(end).format("YYYY-MM-DD");
      let arr = [];
      for (
        date;
        date <= end;
        date = moment(date).add(1, "days").format("YYYY-MM-DD")
      ) {
        arr.push(date);
      }
      return arr;
    },
    filterMeasurePerPosition(list) {
      return new Promise((resolve, reject) => {
        let result = {};
        this.measuresPositions.map(
          (pos) => (result[pos] = list.filter((e) => e.POS == pos))
        );
        resolve(result);
      });
    },
    filterPerMeasureType(list, isET0) {
      return new Promise((resolve, reject) => {
        this.measuresPositions.map((pos) => {
          if (list[pos].length) {
            let typeKeys = list[pos]
              .map((sensor) => sensor.TYPE.split(" ").join(""))
              .filter((type, i, arr) => arr.indexOf(type) == i);
            let aux = {};
            typeKeys.map((key, i) => {
              aux[key] = list[pos].filter(
                (sensor) => sensor.TYPE.split(" ").join("") == key
              );
              if (!isET0 && !i) aux["TYPE"] = aux[key][0]["TYPE"];
            });
            list[pos] = aux;
          } else {
            list[pos] = {};
          }
        });
        resolve(list);
      });
    },
    filterPerDate(list) {
      return new Promise((resolve, reject) => {
        let stationParameters = {
          TEMPERATURADOAR: {},
          PRESSÃOATMOSFÉRICA: {},
          ALTURAPLUVIOMÉTRICA: {},
          RADIAÇÃOSOLAR: {},
          UMIDADERELATIVADOAR: {},
          DIREÇÃODOVENTO: {},
          VELOCIDADEDOVENTO: {},
        };
        this.measuresPositions.map((pos) => {
          if (Object.keys(list[pos]).length) {
            for (let param of Object.keys(list[pos])) {
              this.daysToOrganize.map((day) => {
                stationParameters[param][day] = list[pos][param].filter(
                  (e) => e.TIME.indexOf(day) > -1
                );
              });
            }
          }
        });
        resolve(stationParameters);
      });
    },
    filterPerHour(list) {
      return new Promise((resolve, reject) => {
        let stationParameters = {
          TEMPERATURADOAR: {},
          PRESSÃOATMOSFÉRICA: {},
          ALTURAPLUVIOMÉTRICA: {},
          RADIAÇÃOSOLAR: {},
          UMIDADERELATIVADOAR: {},
          DIREÇÃODOVENTO: {},
          VELOCIDADEDOVENTO: {},
        };
        for (let param of Object.keys(stationParameters)) {
          this.daysToOrganize.map((day) => {
            stationParameters[param][day] = {};
            this.hours.map((h) => {
              stationParameters[param][day][h] = [];
              if (Object.keys(list[param]).length) {
                if (list[param].hasOwnProperty(day) && list[param][day].length)
                  stationParameters[param][day][h] = list[param][day].filter(
                    (e) => e.TIME.indexOf(day + " " + h) > -1
                  );
              }
            });
          });
        }
        // }
        resolve(stationParameters);
      });
    },
    sortKeys(arr) {
      return arr.sort((a, b) => {
        let x = a.toLowerCase();
        let y = b.toLowerCase();
        if (x < y) return -1;
        else if (x > y) return 1;
        else return 0;
      });
    },
    // Quebra explícita: sem ela o título estoura a página e o pdfmake parte em 3 linhas.
    checkType(type) {
      switch (type) {
        case "PRESSÃO ATMOSFÉRICA":
          return "PRESSÃO\nATMOSFÉRICA (hPa)";
        case "TEMPERATURA DO AR":
          return "TEMPERATURA\nDO AR (°C)";
        case "UMIDADE RELATIVA DO AR":
          return "UMIDADE RELATIVA\nDO AR (%rH)";
        case "VELOCIDADE DO VENTO":
          return "VELOCIDADE\nDO VENTO (m/s)";
        case "DIREÇÃO DO VENTO":
          return "DIREÇÃO\nDO VENTO (º)";
        case "PLUVIOMETRIA":
          return "PLUVIOMETRIA\n(mm)";
        case "RADIAÇÃO SOLAR":
          return "RADIAÇÃO\nSOLAR (w/m²)";
        default:
          return type;
      }
    },
    organizeDataToPDF(data) {
      let layout = "lightHorizontalLines";
      let body = [];
      let header = [{ text: "DATA", style: "tableHeader" }];
      Object.keys(data).map((pos) => {
        header.push({
          text:
            data[pos]["TYPE"] === "ALTURA PLUVIOMÉTRICA"
              ? this.checkType("PLUVIOMETRIA")
              : this.checkType(data[pos]["TYPE"]),
          style: "tableHeader",
        });
      });
      body.push(header);
      organizer(this._manipulatedDate, "TIME")
        .map((e) => e.TIME)
        .filter((e, i, arr) => arr.indexOf(e) === i)
        .map((dt, i) => {
          let fillColor = i % 2 == 0 ? "#ffffff" : "#eef2f5";
          let row = [
            {
              text: dt,
              fillColor,
              style: "datetimeCol",
            },
          ]; //inicializa já com a data hora como primeiro coluna
          this.measuresPositions.map((pos) => {
            this.sortKeys(Object.keys(data[pos])).map((key) => {
              if (key != "TYPE") {
                if (data[pos][key].length) {
                  const filtered = data[pos][key].filter(
                    (e) => e.TIME.indexOf(dt) > -1
                  )[0];

                  const hasValue =
                    typeof filtered === "object" &&
                    Reflect.has(filtered, "VALUE");

                  const hasValidValue = hasValue
                    ? isNaN(filtered.VALUE) === false
                    : false;

                  row.push({
                    text:
                      hasValue && hasValidValue
                        ? this.padDecimals(filtered.VALUE, 4)
                        : "-",
                    fillColor,
                    style: "tableData",
                  });
                } else row.push("-");
              }
            });
          });
          body.push(row);
        });

      return {
        date: moment().format("DD/MM/YYYY"),
        local: this.getLocal,
        content: [
          {
            columns: [
              { width: "*", text: "" },
              {
                width: "auto",
                table: {
                  headerRows: 1,
                  // Derivado do cabeçalho; o 7 fixo desalinhava com outra contagem.
                  widths: [95].concat(Array(header.length - 1).fill("auto")),
                  body,
                },
                layout: this.reportTableLayout(),
              },
              { width: "*", text: "" },
            ],
          },
        ],
      };
    },
    makeET0TablePdf(data) {
      return new Promise((resolve, reject) => {
        let layout = "lightHorizontalLines";
        let headerRows = 2;
        let body = [];
        const pendingRain = [];
        if (this.organizeET0.measures == 2) {
          body.push([
            { text: "DATA", style: "tableHeader", rowSpan: 2 },
            { text: "HORA", style: "tableHeader" },
            { text: "TEMP. (°C)", style: "tableHeader", colSpan: 2 },
            {},
            { text: "UMID. (%)", style: "tableHeader", colSpan: 2 },
            {},
            { text: "PTO. ORVALHO (°C)", style: "tableHeader", colSpan: 2 },
            {},
            // Sem rowSpan: o tableHeader é verde e desceria por cima da faixa escura
            // dos MÁX./MÍN. O sub-rótulo abaixo resolve o vão mantendo a faixa inteira.
            ...(this.organizeET0.dpv
              ? [{ text: "DPV (kPa)", style: "tableHeader" }]
              : []),
            { text: "PRESSÃO (hPa)", style: "tableHeader", colSpan: 2 },
            {},
            // Só MÉD. e RAJ. são m/s; DIR. é setor da rosa dos ventos.
            { text: "VENTO (m/s)", style: "tableHeader", colSpan: 2 },
            {},
            { text: "VENTO", style: "tableHeader", colSpan: 2 },
            {},
            { text: "RAD.", style: "tableHeader" },
            { text: "CHUVA", style: "tableHeader" },
            { text: "ETo", style: "tableHeader" },
          ]);
          body.push([
            {},
            { text: "GMT " + this.utc, style: "tableSubHeader" },
            { text: "MÁX.", style: "tableSubHeader" },
            { text: "MÍN.", style: "tableSubHeader" },
            { text: "MÁX.", style: "tableSubHeader" },
            { text: "MÍN.", style: "tableSubHeader" },
            { text: "MÁX.", style: "tableSubHeader" },
            { text: "MÍN.", style: "tableSubHeader" },
            // "MÉD." é literal: o DPV exibido é o do par (Tméd, URméd), o mesmo que o
            // ET0 consome. Também sinaliza que esta coluna não tem par máx/mín.
            ...(this.organizeET0.dpv
              ? [{ text: "MÉD.", style: "tableSubHeader" }]
              : []),
            { text: "MÁX.", style: "tableSubHeader" },
            { text: "MÍN.", style: "tableSubHeader" },
            { text: "MÉD.", style: "tableSubHeader" },
            { text: "RAJ.", style: "tableSubHeader" },
            // dominantDirection() devolve o setor mais frequente, não uma média.
            { text: "PREDOM.", style: "tableSubHeader", colSpan: 2 },
            {},
            { text: this.organizeET0.rad, style: "tableSubHeader" },
            { text: "mm", style: "tableSubHeader" },
            { text: "mm", style: "tableSubHeader" },
          ]);
        } else if (this.organizeET0.measures == 1) {
          body.push([
            { text: "DATA", style: "tableHeader", rowSpan: 2 },
            { text: "HORA", style: "tableHeader" },
            { text: "TEMP. (°C)", style: "tableHeader" },
            { text: "UMID. (%)", style: "tableHeader" },
            { text: "PTO. ORVALHO (°C)", style: "tableHeader" },
            ...(this.organizeET0.dpv
              ? [{ text: "DPV (kPa)", style: "tableHeader" }]
              : []),
            { text: "PRESSÃO (hPa)", style: "tableHeader" },
            // Só MÉD. e RAJ. são m/s; DIR. é setor da rosa dos ventos.
            { text: "VENTO (m/s)", style: "tableHeader", colSpan: 2 },
            {},
            { text: "VENTO", style: "tableHeader", colSpan: 2 },
            {},
            { text: "RAD.", style: "tableHeader" },
            { text: "CHUVA", style: "tableHeader" },
            { text: "ETo", style: "tableHeader" },
          ]);
          body.push([
            {},
            { text: "GMT " + this.utc, style: "tableSubHeader" },
            { text: "MÉD.", style: "tableSubHeader" },
            { text: "MÉD.", style: "tableSubHeader" },
            { text: "MÉD.", style: "tableSubHeader" },
            // O DPV exibido é o do par (Tméd, URméd), então "MÉD." é literal aqui.
            ...(this.organizeET0.dpv
              ? [{ text: "MÉD.", style: "tableSubHeader" }]
              : []),
            { text: "MÉD.", style: "tableSubHeader" },
            { text: "MÉD.", style: "tableSubHeader" },
            { text: "RAJ.", style: "tableSubHeader" },
            // dominantDirection() devolve o setor mais frequente, não uma média.
            { text: "PREDOM.", style: "tableSubHeader", colSpan: 2 },
            {},
            { text: this.organizeET0.rad, style: "tableSubHeader" },
            { text: "mm", style: "tableSubHeader" },
            { text: "mm", style: "tableSubHeader" },
          ]);
        }
        for (let d in this.daysToTable) {
          for (let h in this.hours) {
            let dateTime = `${this.daysToTable[d]} ${this.hours[h]}`;
            let afterStart =
              dateTime >= [this.date.START_DATE, this.date.TIME].join(" ");
            let beforeEnd =
              dateTime <=
              moment([this.date.END_DATE, this.TIME].join(" ")).format(
                "YYYY-MM-DD HH:mm"
              );
            if (afterStart && beforeEnd) {
              let row = [];
              let fillColor = h % 2 == 0 ? "#ffffff" : "#eef2f5";
              /* data & hora */
              row.push(
                {
                  text: moment(this.daysToTable[d]).format("DD-MM-YYYY"),
                  fillColor,
                  style: "datetimeCol",
                },
                {
                  text: this.hours[h],
                  fillColor,
                  style: "datetimeCol",
                }
              );
              const values = this.buildHourlyMeasures(
                this.daysToTable[d],
                this.hours[h]
              );
              const cell = (text) => ({
                text: this.padDecimals(text),
                fillColor,
                style: "tableData",
              });
              // Chuva e ETo são os resultados da estação; o resto da linha são as
              // variáveis que os alimentam.
              const strongCell = (text) => ({
                text: this.padDecimals(text),
                fillColor,
                style: "tableDataStrong",
              });
              this.hourlyColumns.forEach(({ key, paired }) => {
                const cols = paired ? this.organizeET0.measures : 1;
                for (let j = 1; j <= cols; j++) {
                  row.push(cell(values[`${key}${j}`]));
                }
              });
              row.push(
                cell(values.windVel),
                cell(values.windRaj),
                ...this.windDirCells(values.windDir, fillColor),
                cell(values.rad)
              );
              // A chuva é assíncrona: reserva a célula agora e preenche quando chegar.
              // Empurrá-la no .then deixava a linha curta até a promise resolver, e
              // linha curta sai como grade vazia no fim da tabela.
              const rainIndex = row.length;
              row.push(strongCell("-"), strongCell(values.et0));
              // O catch por hora impede que uma falha isolada derrube o relatório
              // inteiro no Promise.all abaixo; a célula fica no "-" já reservado.
              const rainDate = this.daysToTable[d];
              const rainHour = this.hours[h];
              pendingRain.push(
                this.calcPluv(data, rainDate, rainHour)
                  .then((ret) => {
                    row[rainIndex] = strongCell(
                      this.formatReportRow(parseFloat(ret))
                    );
                  })
                  .catch((e) => {
                    console.error(
                      `[ET0] Falha na chuva de ${rainDate} ${rainHour}:`,
                      e.message
                    );
                  })
              );
              body.push(row);
              /* Índices abaixo com DPV ligado; desligado, tudo a partir dele recua 1.
              row se max e min = [
                0: data
                1: hora (GMT -3 -> UCT)
                2: temp max
                3: temp min
                4: humid max
                5: humid min
                6: pto orvalho max
                7: pto orvalho min
                8: DPV (escalar, em kPa)
                9: pres max (em hPa)
                10: press min (em hPa)
                11: vento méd
                12: rajada
                13: seta da direção
                14: direção predominante
                15: radiação (em this.organizeET0.rad) //valores em this.radForET0
                16: chuva,
                17: ET0
              ]
              row se media = [
                0: data
                1: hora (GMT -3 -> UCT)
                2: temp med
                3: humid med
                4: pto orvalho med
                5: DPV (em kPa)
                6: pres med (em hPa)
                7: vento méd
                8: rajada
                9: seta da direção
                10: direção predominante
                11: radiação (em this.organizeET0.rad)
                12: chuva,
                13: ET0
              ] */
            }
          }
        }

        Promise.all(pendingRain).then(() =>
        resolve({
          date: moment().format("DD/MM/YYYY"),
          local: this.getLocal,
          content: [
            {
              // A largura da tabela varia com o toggle do DPV e com o seletor
              // máx/mín × média, então não há margem fixa que a acompanhe. Centralizar
              // resolve: cabeçalho e rodapé viram moldura e a tabela flutua no meio.
              // O pdfmake ignora `alignment` em tabela — só embrulhando em columns.
              // Verificado que preserva quebra de página e repetição do cabeçalho.
              columns: [
                { width: "*", text: "" },
                {
                  width: "auto",
                  table: {
                    headerRows,
                    // A seta é um canvas indivisível: na quebra de página o pdfmake
                    // partia a linha e deixava um resto vazio de 5pt na tabela.
                    dontBreakRows: true,
                    widths: Array(this.et0PdfColumnCount).fill("auto"),
                    body,
                  },
                  // A coluna da seta leva padding menor: 6+6 em volta de um glifo de
                  // 9pt desperdiçava largura.
                  layout: this.reportTableLayout(this.et0ArrowColumnIndex),
                },
                { width: "*", text: "" },
              ],
            },
          ],
        })
        );
      });
    },
    createPDF(data, type) {
      try {
        const BASE_BOTTOM = 30;
        // Altura de uma linha do corpo: fonte 10 (~12,2 de altura de linha) mais o
        // padding vertical 2+2 do pdfmake. Medido igual nas duas tabelas.
        const ROW_HEIGHT = 16.22;
        // O bruto cabia 30 linhas e ficava sufocado; reservar uma linha tira uma.
        const bottomMargin =
          type === "BRUTO" ? BASE_BOTTOM + ROW_HEIGHT : BASE_BOTTOM;
        // O rodapé é desenhado dentro da faixa da margem inferior e subiria junto
        // com ela; o offset o devolve à mesma altura nos dois relatórios.
        const footerOffset = bottomMargin - BASE_BOTTOM;
        const tableSchema = {
          footer: (currentPage, pageCount) => {
            return {
              columns: [
                {
                  text: "Desenvolvido por 3v3 Tecnologia",
                  margin: [PAGE_SIDE_MARGIN, footerOffset, 0, 0],
                  alignment: "left",
                  color: "#999",
                },
                {
                  text: `Página ${currentPage} de ${pageCount}`,
                  margin: [0, footerOffset, PAGE_SIDE_MARGIN, 0],
                  alignment: "right",
                  color: "#999",
                },
              ],
            };
          },
          header: {
            columns: [
              {
                text: data.local,
                alignment: "left",
                margin: [PAGE_SIDE_MARGIN, 20, 0, 0],
                color: "#999",
              },
              {
                text: data.date,
                alignment: "right",
                margin: [0, 20, PAGE_SIDE_MARGIN, 0],
                color: "#999",
              },
            ],
          },
          content: data.content,
          pageOrientation: "landscape",
          // Simétricas para a moldura fazer sentido: 24+24 dá a mesma largura útil
          // do 33+15 anterior (793,9pt), agora repartida igualmente. Topo 40: o texto
          // do cabeçalho tem base em 31,1pt, então abaixo de ~36 começa a encostar.
          pageMargins: [PAGE_SIDE_MARGIN, 40, PAGE_SIDE_MARGIN, bottomMargin],
          styles: {
            tableHeader: {
              fillColor: "#3D9161",
              color: "#fff",
              alignment: "center",
              fontSize: 10,
              bold: true,
            },
            tableSubHeader: {
              fillColor: "#3F4E59",
              alignment: "center",
              color: "#fff",
              fontSize: 9,
              bold: true,
            },
            tableData: {
              fontSize: 10,
              alignment: "center",
            },
            // Mesmas propriedades de datetimeCol, de propósito: o ETo é o resultado do
            // relatório e acompanha o destaque de data/hora. Nada de `color` — cor
            // própria destoava da linha.
            tableDataStrong: {
              fontSize: 10,
              alignment: "center",
              bold: true,
            },
            datetimeCol: {
              fontSize: 10,
              alignment: "center",
              bold: true,
            },
          },
        };

        console.log("Download iniciado...");

        pdfMake.createPdf(tableSchema).open({}, window.open("", "_blank"));
      } catch (error) {
        console.error("Falha ao crir pdf :: ", error);
      }
    },
    calcPluv(list, d, h) {
      let TYPE = "ALTURAPLUVIOMÉTRICA";
      let data = list[TYPE][d][h].map((e) => e.VALUE);
      // Necessária análise do primeiro valor da próxima hora se h < 23
      // Necessária análise do primeiro valor da primeira hora do dia seguinte se h = 23
      // Justificativa: As vezes o valor muda numa virada de hora/dia
      return new Promise((resolve, reject) => {
        if (h < 23) {
          //buscar no mesmo dia o primeiro minuto hora seguinte
          let nextHour = this.hours[parseInt(h) + 1];
          // ifs complexos ganham uma identação horrível
          if (
            list[TYPE][d][h].filter(
              (e) => e.TIME.split(" ")[1].indexOf(h + ":55") > -1
            ).length && //se 'd h:55' (os últimos 5 minutos da hora atual) tiver log
            list[TYPE][d][nextHour] &&
            list[TYPE][d][nextHour].length && //se houver log para a próxima hora
            list[TYPE][d][nextHour].filter(
              (e) => e.TIME.split(" ").indexOf(nextHour + ":00") > -1
            ).length //se 'd h+1:00' (o primeiro minuto da hora seguinte) tiver log
          )
            data.push(
              list[TYPE][d][nextHour].filter(
                (e) => e.TIME.split(" ").indexOf(nextHour + ":00") > -1
              )[0]["VALUE"]
            );
        } else {
          //buscar no dia seguinte o primeiro minuto da primeira hora
          let nextDay = moment(d).add(1, "days").format("YYYY-MM-DD");
          // if (list[TYPE][nextDay] && list[TYPE][nextDay]['00'] && list[TYPE][nextDay]['00'].length) data.push(list[TYPE][nextDay]['00'][0]);
          if (
            list[TYPE][d]["23"] &&
            list[TYPE][d]["23"].length &&
            list[TYPE][d]["23"].filter(
              (e) => e.TIME.split(" ").indexOf("23:55") > -1
            ).length && //se o último minuto da última hora do dia em questão tem log
            list[TYPE][nextDay] &&
            list[TYPE][nextDay]["00"] &&
            list[TYPE][nextDay]["00"].length && //se a primeira hora do dia seguinte tem log
            list[TYPE][nextDay]["00"].filter(
              (
                e //se o primeiro minuto da primeira hora do dia seguinte tem log
              ) => e.TIME.split(" ").indexOf("00:00") > -1
            ).length
          )
            data.push(
              list[TYPE][nextDay]["00"].filter(
                (e) => e.TIME.split(" ").indexOf("00:00") > -1
              )[0]["VALUE"]
            );
        }
        if (data.length) {
          let accumulator = 0;
          let reference = 0;
          let currently = 0;
          data.map((currently, i) => {
            if (currently) {
              let FIRST_NOT_NULL = !accumulator && !reference;
              if (FIRST_NOT_NULL) reference = currently;
              let difference = currently - reference;
              if (difference >= 0) {
                accumulator += difference;
                reference = currently;
              } else {
                if (difference > -reference) {
                  accumulator -= difference;
                  reference = currently;
                }
              }
            }
          });
          resolve(accumulator.toFixed(1));
        } else resolve("-");
      });
      // return data.length ? (data.reduce((acc, e, i, data) => acc + e)).toFixed(2) : '-';
    },
    downloadReport(type = "pdf") {
      this.errors = [];
      let start = this.date.START_DATE;
      let end = this.date.END_DATE;
      if (!this.startState) this.errors.push("Data inicial vazia ou inválida");
      if (!this.endState) this.errors.push("Data final vazia ou inválida");
      if (this.startState && this.endState) {
        if (start > end)
          this.errors.push("Data inicial não pode ser posterior à data final");
        else if (start == end)
          this.errors.push("Data inicial não pode ser igual à data final");
      }
      if (this.InvalidDateDifference) {
        this.errors.push(
          "A diferença entre as datas de início e fim deve ser de no máximo 31 dias"
        );
      }
      if (this.errors.length) this.$refs.formError.show();
      else {
        switch (this.date.type) {
          case "et0":
            this.searchDataToET0(type);
            break;
          case "pure":
            this.searchPureData(type);
            break;
        }
      }
    },
    CleanTabulator() {
      this.tableData = [];
      this.tableColumns = [];
      this.typeTable = "";
      this.createTabulator = false;
    },
    // Seta vetorial + sigla. Vetor porque a Roboto do pdfmake não tem glifo de seta
    // nenhum (nem emoji), e canvas ainda cobre os 16 setores, contra 8 de glifos.
    windDirCells(dir, fillColor) {
      const bearing = WINDROSE_BEARINGS[dir];
      const label = { text: dir, fillColor, style: "tableData" };
      if (bearing === undefined) {
        return [{ text: "", fillColor, style: "tableData" }, label];
      }
      const size = 9;
      const c = size / 2;
      const r = c - 0.5;
      const at = (deg, dist, from) => {
        const a = (deg * Math.PI) / 180;
        return {
          x: from.x + dist * Math.sin(a),
          y: from.y - dist * Math.cos(a),
        };
      };
      const center = { x: c, y: c };
      const tip = at(bearing, r, center);
      const tail = at(bearing + 180, r, center);
      return [
        {
          fillColor,
          margin: [0, 1, 0, 0],
          canvas: [
            {
              type: "line",
              x1: tail.x,
              y1: tail.y,
              x2: tip.x,
              y2: tip.y,
              lineWidth: 0.8,
            },
            {
              type: "polyline",
              closePath: true,
              color: "#000",
              points: [
                tip,
                at(bearing + 140, r * 0.8, tip),
                at(bearing - 140, r * 0.8, tip),
              ],
            },
          ],
        },
        label,
      ];
    },
    // Grade dos relatórios em PDF. O hLine de 0.25 não é enfeite: sem nenhuma
    // horizontal, o pdfmake desenha as verticais 31pt além da última linha na quebra.
    reportTableLayout(tightColumn = null) {
      return {
        hLineWidth: (i, node) =>
          i === node.table.headerRows
            ? 2
            : i === node.table.body.length
            ? 1
            : 0.25,
        hLineColor: (i, node) =>
          i === node.table.headerRows ? "#000" : "#d0d5d9",
        vLineWidth: () => 1,
        vLineColor: () => "#d0d5d9",
        paddingLeft: (i) => (i === tightColumn ? 3 : 6),
        paddingRight: (i) => (i === tightColumn ? 3 : 6),
      };
    },
    // Só para as células do PDF: o formatReportRow devolve Number e perde o zero à
    // direita ("27.00" -> 27). Não-numérico (direção, "-") passa intacto.
    padDecimals(value, decimal = 2) {
      return value === null || value === undefined || value === "" || isNaN(value)
        ? value
        : Number(value).toFixed(decimal);
    },
    formatReportRow(value, decimal = 2) {
      if (isNaN(value)) {
        return "-";
      }
      const toFixed = Number(value).toFixed(decimal);
      return Number(toFixed);
    },
    buildEt0Map(hourly) {
      const map = {};
      for (const row of hourly) {
        const hh = String(row.hour).padStart(2, "0");
        if (!map[row.date]) map[row.date] = {};
        map[row.date][hh] = row;
      }
      return map;
    },
    hourAt(date, hh) {
      const day = this.et0Map[date];
      return day ? day[hh] : undefined;
    },
    // Adapta o objeto horário do backend ao formato antigo do `aux` (temp/humid/dew/pres/wind)
    // + rad + et0. Hora sem leitura vira "-"/NaN, que o formatReportRow converte em "-".
    hourStats(date, hh) {
      const H = this.hourAt(date, hh);
      if (!H || !H.hasData) {
        const dash = { max: "-", min: "-", med: "-" };
        return {
          temp: { ...dash },
          humid: { ...dash },
          dew: { ...dash },
          vpd: "-",
          pres: { ...dash },
          wind: { vel: "-", dir: "-", raj: "-" },
          rad: "-",
          et0: NaN,
        };
      }
      const rad =
        this.organizeET0.rad === "kJ/m²" ? H.radiationEnergy : H.radiation.avg;
      return {
        temp: { max: H.temp.max, min: H.temp.min, med: H.temp.avg },
        humid: { max: H.humid.max, min: H.humid.min, med: H.humid.avg },
        dew: { max: H.dewPoint.max, min: H.dewPoint.min, med: H.dewPoint.avg },
        vpd: H.vpd,
        pres: {
          max: H.pressure.max,
          min: H.pressure.min,
          med: H.pressure.avg,
        },
        wind: { vel: H.wind.avg, dir: H.wind.dir || "-", raj: H.wind.max },
        rad,
        et0: H.et0,
      };
    },
    // Medições de uma hora, compartilhadas por makeET0TablePdf/organizeTabulatorCSV/organizeTabulator.
    // Chuva fica de fora: é assíncrona via calcPluv, cada chamador mantém seu próprio .then().
    buildHourlyMeasures(date, hour) {
      const aux = this.hourStats(date, hour);
      const arr2 = this.organizeET0.measures == 2 ? ["max", "min"] : ["med"];
      const values = {};
      this.hourlyColumns.forEach(({ key, paired }) => {
        if (!paired) {
          values[`${key}1`] = this.formatReportRow(parseFloat(aux[key]));
          return;
        }
        arr2.forEach((stat, i) => {
          values[`${key}${i + 1}`] = this.formatReportRow(
            parseFloat(aux[key][stat])
          );
        });
      });
      values.windVel = this.formatReportRow(parseFloat(aux.wind.vel));
      values.windDir = aux.wind.dir || "-";
      values.windRaj = this.formatReportRow(parseFloat(aux.wind.raj));
      values.rad = this.formatReportRow(parseFloat(aux.rad));
      values.et0 = this.formatReportRow(aux.et0);
      return values;
    },
    formatPureDataToTabulatorFormat(data, fileFormat) {
      console.log("Gerando relatório... ");

      this.typeTable = fileFormat;
      this.createTabulator = false;
      // let layout = "lightHorizontalLines";
      // let body = [];
      let index = 0;

      const tableColumns = [
        { title: "DATA", field: "DATA" },
        ...this.measuresPositions.map((measurePosition) => {
          const measureName = data[measurePosition]["TYPE"];
          return {
            title: measureName,
            field: measureName,
          };
        }),
      ];

      // No repeated datetimes
      const datetimes = organizer(this._manipulatedDate, "TIME")
        .map((e) => e.TIME)
        .filter((e, i, arr) => arr.indexOf(e) === i);

      const tableRows = datetimes.map((datetime, i) => {
        // let fillColor = i % 2 == 0 ? "#ffffff" : "#eef2f5";
        //inicializa já com a data hora como primeiro coluna
        const dateTimeColumnName = tableColumns[0].field;

        const row = {
          id: index,
          [dateTimeColumnName]: datetime,
        };
        // Object.assign(row, { id: index, [tableColumns[0].field]: datetime });

        this.measuresPositions.forEach((measurePosition) => {
          const measures = data[measurePosition];

          const measuresNames = Object.keys(measures);

          this.sortKeys(measuresNames).map((measureName) => {
            if (measureName != "TYPE") {
              const measureData = data[measurePosition][measureName];

              if (measureData.length) {
                let filtered = measureData.filter(
                  (e) => e.TIME.indexOf(datetime) > -1
                )[0];

                if (filtered) {
                  Object.assign(row, {
                    [tableColumns[
                      tableColumns.findIndex((e) => e.field === filtered.TYPE)
                    ].field]: this.formatReportRow(filtered.VALUE),
                  });
                }
              }
              // else row.push({});
            }
          });
        });

        // datas.push(row);
        index++;
        return row;
      });

      this.tableData = tableRows;
      this.tableColumns = tableColumns;
      this.createTabulator = true;
    },
    // Especificação única das colunas do relatório horário exportado. CSV usa
    // `titulo` (colunas planas), XLSX usa `grupo` + `sub` (colunas agrupadas), e a
    // linha é montada por `field`. Antes cada função repetia a lista nos dois modos
    // e a linha era escrita por índice (`tableColumns[6]`), o que fazia inserir uma
    // coluna deslocar todas as seguintes.
    et0ExportColumns() {
      const stats = this.organizeET0.measures == 2 ? ["MÁX.", "MÍN."] : ["MÉD."];
      const numero = (c) => ({
        ...c,
        formatter: (cell) => this.formatReportRow(parseFloat(cell.getValue())),
      });
      const par = (base, unidade, chave) =>
        stats.map((stat, i) =>
          numero({
            field: `${chave}_${i + 1}`,
            grupo: `${base} (${unidade})`,
            sub: stat,
            titulo: `${base} ${stat} (${unidade})`,
            valor: (v) => v[`${chave}${i + 1}`],
          })
        );

      return [
        { field: "DATA", grupo: "DATA", titulo: "DATA", valor: (v, c) => c.data },
        {
          field: "HORA",
          grupo: "HORA",
          sub: `GMT ${this.utc}`,
          titulo: `HORA (GMT) ${this.utc}`,
          valor: (v, c) => c.hora,
        },
        ...par("TEMPERATURA", "°C", "temp"),
        ...par("UMIDADE", "%", "humid"),
        ...par("PTO. ORVALHO", "°C", "dew"),
        ...(this.organizeET0.dpv
          ? [
              numero({
                field: "DPV",
                grupo: "DPV (kPa)",
                sub: "MÉD.",
                titulo: "DPV MÉD. (kPa)",
                valor: (v) => v.vpd1,
              }),
            ]
          : []),
        ...par("PRESSÃO", "hPa", "pres"),
        numero({
          field: "VENTO_MED",
          grupo: "VENTO (m/s)",
          sub: "MÉD.",
          titulo: "VENTO MÉD. (m/s)",
          valor: (v) => v.windVel,
        }),
        numero({
          field: "VENTO_RAJ",
          grupo: "VENTO (m/s)",
          sub: "RAJ.",
          titulo: "VENTO RAJ. (m/s)",
          valor: (v) => v.windRaj,
        }),
        // Fora do grupo (m/s): é setor da rosa dos ventos, não velocidade.
        {
          field: "VENTO_DIR",
          grupo: "VENTO",
          sub: "PREDOM.",
          titulo: "VENTO PREDOM.",
          valor: (v) => v.windDir,
        },
        numero({
          field: "RADIACAO",
          grupo: "RADIAÇÃO",
          sub: this.organizeET0.rad,
          titulo: `RADIAÇÃO (${this.organizeET0.rad})`,
          valor: (v) => v.rad,
        }),
        numero({
          field: "CHUVA",
          grupo: "CHUVA",
          sub: "mm",
          titulo: "CHUVA (mm)",
          chuva: true,
        }),
        numero({
          field: "ETO",
          grupo: "ETo",
          sub: "mm",
          titulo: "ETo (mm)",
          valor: (v) => v.et0,
        }),
      ];
    },
    // Percorre as horas do período montando uma linha por hora. A chuva é assíncrona:
    // a célula é reservada e preenchida quando chega, e o resolve espera todas —
    // empurrá-la depois deixava a linha incompleta.
    buildEt0ExportRows(data, colunas) {
      const chuva = colunas.find((c) => c.chuva);
      const pendentes = [];
      const body = [];
      let index = 0;

      for (const d in this.daysToTable) {
        for (const h in this.hours) {
          const dateTime = `${this.daysToTable[d]} ${this.hours[h]}`;
          const afterStart =
            dateTime >= [this.date.START_DATE, this.date.TIME].join(" ");
          const beforeEnd =
            dateTime <=
            moment([this.date.END_DATE, this.date.TIME].join(" ")).format(
              "YYYY-MM-DD HH:mm"
            );
          if (afterStart && beforeEnd) {
            const values = this.buildHourlyMeasures(
              this.daysToTable[d],
              this.hours[h]
            );
            const ctx = { data: this.daysToTable[d], hora: this.hours[h] };
            const row = { id: index };
            for (const c of colunas) {
              row[c.field] = c.chuva ? "-" : c.valor(values, ctx);
            }

            const rainDate = this.daysToTable[d];
            const rainHour = this.hours[h];
            pendentes.push(
              this.calcPluv(data, rainDate, rainHour)
                .then((ret) => {
                  row[chuva.field] = this.formatReportRow(parseFloat(ret));
                })
                .catch((e) => {
                  console.error(
                    `[ET0] Falha na chuva de ${rainDate} ${rainHour}:`,
                    e.message
                  );
                })
            );
            body.push(row);
          }
          index++;
        }
      }
      return Promise.all(pendentes).then(() => body);
    },
    organizeTabulatorCSV(data) {
      console.log("Gerando relatório em csv... ");
      this.createTabulator = false;
      const colunas = this.et0ExportColumns();
      const tableColumns = colunas.map((c) => ({
        title: c.titulo,
        field: c.field,
        ...(c.formatter ? { formatter: c.formatter } : {}),
      }));
      return this.buildEt0ExportRows(data, colunas).then((body) => [
        body,
        tableColumns,
      ]);
    },
    organizeTabulator(data) {
      console.log("Gerando relatório... ");
      this.createTabulator = false;
      const colunas = this.et0ExportColumns();
      // Colunas consecutivas com o mesmo `grupo` viram um cabeçalho agrupado.
      const tableColumns = [];
      for (const c of colunas) {
        const filha = { title: c.sub, field: c.field, download: true };
        if (!c.sub) {
          tableColumns.push({ title: c.grupo, field: c.field, download: true });
          continue;
        }
        const ultimo = tableColumns[tableColumns.length - 1];
        if (ultimo && ultimo.columns && ultimo.title === c.grupo) {
          ultimo.columns.push(filha);
        } else {
          tableColumns.push({
            title: c.grupo,
            download: true,
            columns: [filha],
          });
        }
      }
      return this.buildEt0ExportRows(data, colunas).then((body) => [
        body,
        tableColumns,
      ]);
    },
    // NOTE: Qual o sentido desse cálculo?
    organizeDataRainfall(data) {
      let lastOccurrence = data[data.length - 1].VALUE;
      data.map((item) => {
        let diff = item.VALUE - lastOccurrence;
        item.VALUE = Number(diff.toFixed(3));
      });
    },
    searchDataToET0(type) {
      wait.show();
      this.daysToTable = this.makeDaysArray(
        this.date.START_DATE,
        this.date.END_DATE
      );
      this.daysToOrganize = this.daysToTable.map((e) => e);
      this.daysToOrganize.push(
        moment(this.date.END_DATE).add(1, "days").format("YYYY-MM-DD")
      );
      let data = this.date;
      data.NAME = this.chartItems.length ? this.chartItems[0].NAME : "";
      // data.ADDR = this.station.ADDR;
      stations
        .exportData(data)
        .then((response) => {
          if (response[0].length) {
            const itemsWithFormatedDates = response[0].map((data) => {
              data.TIME = moment(data.TIME).format("YYYY-MM-DD HH:mm");
              if (!this.measuresPositions.includes(data.POS)) {
                this.measuresPositions.push(data.POS);
              }
              return data;
            });

            return this.filterMeasurePerPosition(itemsWithFormatedDates);
          } else {
            alert(
              "Não há dados disponíveis para o período ou para os sensores.",
              "e"
            );
            setTimeout(wait.hide(), 2000);
            throw "Não há dados disponíveis para o período ou para os sensores.";
          }
        })
        .then((ret) => {
          return this.filterPerMeasureType(ret, true);
        })
        .then((ret) => this.filterPerDate(ret))
        .then((ret) => this.filterPerHour(ret))
        .then((ret) =>
          // ET0 + stats horárias vêm do backend numa única requisição (≤ 744 linhas).
          stations
            .calcEt0({
              from: this.date.START_DATE,
              to: this.date.END_DATE,
              granularity: "hourly",
            })
            .then(({ hourly }) => {
              this.et0Map = this.buildEt0Map(hourly || []);
              return ret;
            })
        )
        .then((ret) => {
          if (type === "xlsx") {
            this.organizeTabulator(ret).then((data) => {
              this.createTabulator = true;
              this.typeTable = "xlsx";
              this.tableData = data[0];
              this.tableColumns = data[1];
              return;
            });
            return;
          } else if (type === "csv") {
            this.organizeTabulatorCSV(ret).then((data) => {
              this.createTabulator = true;
              this.typeTable = "csv";
              this.tableData = data[0];
              this.tableColumns = data[1];
              return;
            });
            return;
          } else {
            return this.makeET0TablePdf(ret);
          }
        })
        .then((ret) => {
          if (ret) {
            this.createPDF(ret, "ET0");
          } else {
            return;
          }
        })
        .catch((err) => {
          setTimeout(wait.hide(), 2000);
          console.error(err);
        })
        .finally(() => wait.hide());
    },
    searchPureData(type) {
      wait.show();
      // this.showWaitDialog();
      this.daysToTable = this.makeDaysArray(
        this.date.START_DATE,
        this.date.END_DATE
      );
      let data = this.date;
      // data.ADDR = this.station.ADDR;
      data.NAME = this.chartItems.length ? this.chartItems[0].NAME : "";
      stations
        .exportData(data)
        .then((response) => {
          // if (ret.status) {
          if (response[0].length) {
            this._manipulatedDate = response[0].map((item) => {
              item.TIME = moment(item.TIME).format("YYYY-MM-DD HH:mm");
              if (!this.measuresPositions.includes(item.POS)) {
                this.measuresPositions.push(item.POS);
              }
              return item;
            });
            return this.filterMeasurePerPosition(this._manipulatedDate);
          } else {
            alert(
              "Não há dados disponíveis para o período ou para os sensores.",
              "e"
            );
            setTimeout(wait.hide(), 2000);
            throw "Não há dados disponíveis para o período ou para os sensores.";
          }
          // } else {
          //   alert(ret.log, ret.alert);
          //   setTimeout(wait.hide(), 2000);
          //   throw ret.log;
          // }
        })
        .then((ret) => {
          console.log("Organizando dados...");
          return this.filterPerMeasureType(ret);
        })
        .then((ret) => {
          //Calcular a diferença de valres quando for altura pluviométrica, exibindo só
          // a variação com base no primeiro valor registrado
          // let keys = Object.keys(ret);
          // for (let key of keys) {
          //   if (ret[key].TYPE === "ALTURA PLUVIOMÉTRICA") {
          //     let obj = ret[key]["ALTURAPLUVIOMÉTRICA"];
          //     this.organizeDataRainfall(obj);
          //   }
          // }

          if (["xlsx", "csv", "html"].includes(type)) {
            this.formatPureDataToTabulatorFormat(ret, type);
          } else {
            console.log(`Criando PDF`);
            const pdfData = this.organizeDataToPDF(ret);
            if (pdfData) {
              this.createPDF(pdfData, "BRUTO");
            }
          }
        })
        // .then((ret) => {
        //   if (ret) {
        //     return this.createPDF(ret, "BRUTO");
        //   } else {
        //     return;
        //   }
        // })
        .catch((err) => {
          console.error(
            `Erro na construção do relatório de dados brutos no formato ${type}`,
            err
          );
          setTimeout(wait.hide(), 2000);
          alert(
            `Erro na construção do relatório de dados brutos no formato ${type}`,
            "w"
          );
        })
        .finally(() => wait.hide());
    },
  },
};
</script>

<style scoped>
.container-card {
  transition: all 0.4s;
  padding: 10px;

  border-radius: 4px;
  box-shadow: 0 1px 3px rgb(0 0 0 / 12%), 0 1px 2px rgb(0 0 0 / 24%);
  transition: all 0.4s ease;
}
.container-card button {
  font-size: 0.8em;
}
.group-info .title {
  font-weight: 600;
}
.title-card {
  font-size: 1.3em;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  max-height: 28px;
}
.title-card span {
  padding-top: 4px;
  margin-left: 4px;
}
.container-card .config-details {
  font-size: 0.87em;
  color: var(--text-gray-primary);
}
.config-details .station-health-alert {
  overflow-wrap: anywhere;
}
.config-details .station-health-list {
  padding-left: 18px;
}
/* Lado a lado: o banner herda a altura da coluna de infos (flex) e só rola se exceder. */
@media screen and (min-width: 768px) {
  .config-details .health-col {
    position: relative;
  }
  .config-details .health-col .station-health-alert {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0.5rem;
    right: 0.5rem;
    overflow-y: auto;
    overflow-x: hidden;
  }
}
.bg-logo-monit {
  position: fixed;
  width: 100%;
  height: 80vh;
  z-index: -3;
  margin-left: -55px;
}
.monitCard.station {
  padding-top: 17px;
  max-height: 60px;
  text-align: center;
}
.monitCard.sensor-station {
  height: 80px;
}
.detail {
  max-height: 69vh;
}

@media screen and (max-width: 767px) {
  .monit-page {
    padding-top: 32px;
  }
  .monit-page .monit-main {
    width: 100% !important;
    transition: 0.1s;
    overflow-y: auto;
    height: 100%;
  }
}
@media screen and (max-width: 280px) {
  .title-card {
    font-size: 1.1em;
  }
}
.detail-measure {
  border-color: transparent;
  padding: 12px;
}
.station-monit .disabled-link {
  cursor: default;
  pointer-events: none;
}
.station-monit .disabled-link .monitCard {
  opacity: 0.6;
}
.detail .measures h5 {
  margin-bottom: 0;
}
.margin-bottom {
  margin-bottom: 10px;
}
</style>
